import { useEffect, useRef, useState } from "react";

// Type-to-search multi-officer picker. Search by name or mobile, click a
// match to add it to the list below; repeat. `value` is an array of officer
// ids; `onChange` receives the new array.
export default function OfficerMultiSelect({ officers, value, onChange }) {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  // Close the suggestion list when clicking outside.
  useEffect(() => {
    const onDocClick = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const label = (o) =>
    o.full_name + (o.mobile ? ` · 📱 ${o.mobile}` : "");

  const selected = officers.filter((o) => value.includes(o.id));
  const q = query.trim().toLowerCase();
  const matches = officers
    .filter((o) => !value.includes(o.id)) // hide already-added officers
    .filter(
      (o) =>
        !q ||
        (o.full_name || "").toLowerCase().includes(q) ||
        (o.mobile || "").includes(query.trim())
    )
    .slice(0, 8);

  const add = (id) => {
    onChange([...value, id]);
    setQuery("");
    setOpen(false);
  };
  const remove = (id) => onChange(value.filter((x) => x !== id));

  return (
    <div>
      <div ref={boxRef} style={{ position: "relative" }}>
        <input
          placeholder="Search officer by name or mobile…"
          value={query}
          onChange={(e) => {
            setQuery(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
        />
        {open && (
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              zIndex: 50,
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: 4,
              marginTop: 2,
              maxHeight: 220,
              overflowY: "auto",
              boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
            }}
          >
            {matches.length === 0 ? (
              <div
                className="muted"
                style={{ padding: "8px 10px", fontSize: 13 }}
              >
                No officers found.
              </div>
            ) : (
              matches.map((o) => (
                <div
                  key={o.id}
                  onClick={() => add(o.id)}
                  style={{
                    padding: "8px 10px",
                    cursor: "pointer",
                    fontSize: 13,
                    borderBottom: "1px solid #f0f0f0",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background = "#f0f4f8")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = "#fff")
                  }
                >
                  {label(o)}
                </div>
              ))
            )}
          </div>
        )}
      </div>

      {/* Officers picked so far — each saved below the search field. */}
      {selected.length > 0 && (
        <div
          style={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}
        >
          {selected.map((o) => (
            <div
              key={o.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 10px",
                border: "1px solid #ddd",
                borderRadius: 4,
                background: "#f6f8fa",
              }}
            >
              <span style={{ flex: 1, fontSize: 13 }}>{label(o)}</span>
              <button
                type="button"
                className="btn btn-sm"
                onClick={() => remove(o.id)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
